<template>
  <el-dialog
    :modal-append-to-body="false"
    :append-to-body="true"
    :title="'預約單號:' + title"
    :visible.sync="dialogVisible"
    width="900px"
    top="2%"
  >
    <el-row>
      <el-form label-width="80px">
        <el-col :span="12">
          <el-form-item label="機構:">
            <el-input v-model="obj.company" disabled> </el-input>
          </el-form-item>
          <el-form-item label="入住時間:">
            <el-input v-model="obj.arrival" disabled> </el-input>
          </el-form-item>
          <el-form-item label="預計費用:">
            <el-input v-model="obj.totalRate" disabled> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="住宿類型:">
            <el-input v-model="obj.type" disabled> </el-input>
          </el-form-item>
          <el-form-item label="退宿時間:">
            <el-input v-model="obj.departure" disabled> </el-input>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-button
      size="small"
      type="primary"
      style="margin: 10px 0"
      @click="newItem()"
    >
      開單
    </el-button>
    <el-table
      scripe
      :data="tableData"
      style="width: 100%; color: black"
      ref="multipleTable"
    >
      <el-table-column label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="handleEdit(scope.row)">
            詳情
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="consoleLog(scope.row.OperateCode)"
          >
            打印
          </el-button>
          <el-button
            v-if="scope.row.NoteCode == ''"
            size="small"
            type="primary"
            @click="handleOK(scope.row.OperateCode)"
          >
            提交
          </el-button>
          <el-button
            v-if="scope.row.NoteCode !== ''"
            size="small"
            :type="scope.row.IsOfficial ? 'success' : ''"
            @click="noteOfficial(scope.row)"
          >
            {{ scope.row.IsOfficial ? "正式版" : "非正式版" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="單據編號"
        prop="NoteCode"
        :show-overflow-tooltip="true"
      />
      <el-table-column label="Balance" prop="Balance" />
      <el-table-column label="開單日期" prop="CreateDate" />
    </el-table>
    <strong>
      Balance:
      {{ moneyStr(balance) }}
    </strong>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false"
        >關閉</el-button
      >
    </span>
    <finance-detail
      ref="financeDetail"
      @handleSuccess="getList"
    ></finance-detail>
  </el-dialog>
</template>
<script>
import { downloadFileByBlob } from "@/utils/utils";
import { finance, confirmDebit, setOfficial } from "@/api/guest/list";
import FinanceDetail from "./FinanceDetail";
import { download } from "@/api/download";
export default {
  components: {
    FinanceDetail,
  },
  data() {
    return {
      url: "/BookingManagement/GeneratePdf",
      title: "單號",
      dialogVisible: false,
      obj: {},
      tableData: [],
      selectedDebit: "",
    };
  },
  computed: {
    balance() {
      return this.tableData.reduce((total, item) => {
        return total + Number(item.Balance);
      }, 0);
    },
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.tableData = [];
      }
    },
    canPrint() {
      let result = true;
      console.log(this.tableData);
      this.tableData.map((_) => {
        if (_.CanEdit) {
          result = false;
        }
      });
      return result;
    },
  },
  methods: {
    consoleLog(code) {
      download(this.url, {
        BookingCode: this.title,
        DebitOperateCode: code,
      }).then((content) => {
        console.log(content);
        var blobContent = new Blob([content]);
        downloadFileByBlob(blobContent, "賬務清單.pdf");
      });
    },
    handleOK(code) {
      this.$confirm("提交後不可變更，是否繼續？").then(() => {
        confirmDebit({ OperateCode: code }).then(() => {
          this.$message({
            message: this.$t("app.opeSuccess"),
            type: "success",
          });
          this.getList();
        });
      });
    },
    newItem() {
      this.$refs.financeDetail.newModal(this.title, this.obj.totalRate);
    },
    handleEdit(row) {
      this.$refs.financeDetail.edit(row);
    },
    moneyStr(num) {
      const arr = num.toString().split(".");
      arr[0] = arr[0].toLocaleString().replace(/^0*/, "");
      if (arr[0] === "") {
        arr[0] = "0";
      }
      arr[1] = arr[1] || "00";
      return arr[0] + "." + (arr[1] + "00").slice(0, 2);
    },
    open(row) {
      this.dialogVisible = true;
      this.title = row.code;
      this.obj = JSON.parse(JSON.stringify(row));
      this.getList();
    },
    getList() {
      finance({
        BookingCode: this.title,
      }).then((res) => {
        this.tableData = res.data.DebitNoteGroup;
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    noteOfficial(row) {
      let tooltip = "是否標記為客戶正式版單據？";
      if (row.IsOfficial) {
        tooltip = "是否取消正式版標記？";
      }
      this.$confirm(tooltip).then(() => {
        setOfficial({
          BookingCode: this.title,
          DebitOperateCode: row.NoteCode,
          IsOfficial: row.IsOfficial,
        }).then(() => {
          this.$message({
            message: this.$t("app.opeSuccess"),
            type: "success",
          });
          this.getList();
        });
      });
    },
  },
};
</script>
